import { FC, useCallback } from 'react';
import { ButtonToggle, Flex } from '@servicetitan/anvil2';

import { IQuestionOptionModel } from '../models/questions.model';
import { useDependencies } from '@servicetitan/react-ioc';
import { QuestionsStore } from '../stores/questions.store';
import { BattlecardStore } from '../../common/stores/battlecard.store';

interface QuestionsOptionsProps {
    questions: IQuestionOptionModel[];
    onSelect: (question: IQuestionOptionModel) => void;
}

export const QuestionsOptions: FC<QuestionsOptionsProps> = ({ onSelect, questions }) => {
    const [questionsStore, battlecardStore] = useDependencies<[QuestionsStore, BattlecardStore]>(
        QuestionsStore,
        BattlecardStore
    );

    const handleClick = (question: IQuestionOptionModel) => {
        if (question.isGroup) {
            if (questionsStore.selectedQuestionGroup?.id === question.id) {
                return;
            }
        } else {
            if (questionsStore.selectedQuestion?.id === question.id) {
                return;
            }
        }
        onSelect(question);
    };

    const isChecked = useCallback(
        (question: IQuestionOptionModel) => {
            if (question.isGroup) {
                return question.id === questionsStore.selectedQuestionGroup?.id;
            }
            return question.id === questionsStore.selectedQuestion?.id;
        },
        [questionsStore.selectedQuestion?.id, questionsStore.selectedQuestionGroup?.id]
    );

    return (
        <Flex className="w-100" wrap="wrap" gap="1">
            {questions.map(question => (
                <ButtonToggle
                    checked={isChecked(question)}
                    disabled={
                        battlecardStore.battlecardError && questionsStore.isStInfoTopicSelected
                    }
                    className="m-b-1"
                    key={question.id}
                    onClick={() => handleClick(question)}
                >
                    {question.text}
                </ButtonToggle>
            ))}
        </Flex>
    );
};
